// extracted by mini-css-extract-plugin
export var disabled = "Disabled-module--disabled--37e9d";